import { render, staticRenderFns } from "./addOrEditGoods.vue?vue&type=template&id=5da74330&scoped=true&"
import script from "./addOrEditGoods.vue?vue&type=script&lang=js&"
export * from "./addOrEditGoods.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditGoods.vue?vue&type=style&index=0&id=5da74330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da74330",
  null
  
)

export default component.exports